/**
 * Application configuration
 * All values are loaded from environment variables
 */

export const config = {
  // Environment
  profile: import.meta.env.VITE_PROFILE || 'development',
  isDevelopment: import.meta.env.VITE_PROFILE === 'development',
  isStaging: import.meta.env.VITE_PROFILE === 'staging',
  isProduction: import.meta.env.VITE_PROFILE === 'production',

  // Medplum
  medplum: {
    baseUrl: (import.meta.env.VITE_MEDPLUM_BASE_URL || 'https://api.medplum.com/').trim(),
    /** Trimmed — pilot Users are project-scoped; login must include clientId or projectId from env. */
    clientId: (import.meta.env.VITE_MEDPLUM_CLIENT_ID || '').trim(),
    /**
     * OAuth client secret for `startClientLogin` when no interactive user session.
     * Exposed in the browser bundle — use only for local/dev; production should use a backend or Medplum-hosted proxy.
     */
    clientSecret: (import.meta.env.VITE_MEDPLUM_CLIENT_SECRET || '').trim(),
    projectId: (import.meta.env.VITE_MEDPLUM_PROJECT_ID || '').trim(),
    /** Single patient ID used for all assessment assignments and client portal documents (seed patient). */
    clientPatientId: '11111111-1111-4111-a111-111111111111',
  },

  // Auth0
  auth0: {
    domain: import.meta.env.VITE_AUTH0_DOMAIN || '',
    clientId: import.meta.env.VITE_AUTH0_CLIENT_ID || '',
    audience: import.meta.env.VITE_AUTH0_AUDIENCE || '',
    // Auth0 authorize URL constructed from domain
    get authorizeUrl() {
      return `https://${import.meta.env.VITE_AUTH0_DOMAIN}/authorize`;
    },
  },

  // Application
  app: {
    url: import.meta.env.VITE_APP_URL || 'http://localhost:3015',
    callbackUrl: import.meta.env.VITE_CALLBACK_URL || 'http://localhost:3015/auth/callback',
  },

  // Backend API
  api: {
    url: import.meta.env.VITE_API_URL || 'http://localhost:8080',
  },

  // Zoom Meeting SDK
  zoom: {
    sdkKey: import.meta.env.VITE_ZOOM_SDK_KEY || '',
    sdkSecret: import.meta.env.VITE_ZOOM_SDK_SECRET || '',
    get enabled() {
      return import.meta.env.VITE_ZOOM_ENABLED
        ? import.meta.env.VITE_ZOOM_ENABLED === 'true'
        : Boolean(this.sdkKey);
    },
  },
} as const;
